import { useSession } from 'next-auth/react';
import { FC, memo, useState } from 'react';
import { Button, ButtonProps } from '@components/UIKit/Button/Button';
import { useTranslation } from '@hooks/useTranslation';
import { SocialManagerView } from '@specs/views';
import { UnblockFlow } from '@components/Modals/Variants/UnblockFlow/UnblockFlow';
const defaultButtonProps: Omit<ButtonProps, 'children' | 'id'> = {
  size: 'medium',
  color: 'Black'
};
interface Props {
  shortid: SocialManagerView.publicProfile['shortid'];
}
const MemoizedUnblockButton: FC<Props> = ({
  shortid
}) => {
  const {
    status
  } = useSession();
  const {
    translate: tr
  } = useTranslation();
  const [isUnblockModalOpen, setIsUnblockModalOpen] = useState(false);
  return <>
			<UnblockFlow isOpen={isUnblockModalOpen} onClose={() => setIsUnblockModalOpen(false)} targetShortId={shortid} data-sentry-element="UnblockFlow" data-sentry-source-file="UnblockButton.tsx" />
			<Button id='follow_button' {...defaultButtonProps} onClick={() => setIsUnblockModalOpen(true)} disabled={status === 'unauthenticated'} data-sentry-element="Button" data-sentry-source-file="UnblockButton.tsx">
				{tr({
        id: 'btn.unblock'
      })}
			</Button>
		</>;
};
export const UnblockButton = memo(MemoizedUnblockButton);